import Cookies from 'cookies-js';

export default function getFileUploadHeaders() {
  if (process.env.NODE_ENV !== 'production') {
    const developCookie = 'f^msnddsfnblj6-4ne8_^==h9)^p^v@#ut7uvx$pdqo&*a1re9';
    return {
      'X-CSRFToken': Cookies.get('csrftoken'),
      'X-AID': developCookie,
    };
  }
  return {
    'X-CSRFToken': Cookies.get('csrftoken'),
  };
}



// WEBPACK FOOTER //
// ./src/services/http-file-headers.js